import React, { Component } from 'react'
import ExchangeItem from '../ExchangeItem'
import Separator from '../../../../components/Separator'
import { bindActionCreators } from 'redux'
import { updateContinueState } from '../../../../components/Footer/thunk'
import { connect } from 'react-redux'

class ExchangeItemsList extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filledItems: {},
		}
	}

	/**
	 * onFilledFieldAction {Function}
	 * @description - change state about filled in fields on exchange step on change action
	 * */
	onFilledFieldAction = (id, isFilled) => {
		this.setState({
			filledItems: {
				...this.state.filledItems,
				[id]: isFilled,
			},
		})
	}

	/**
	 * getExchangeContinueState {Function}
	 * @description - check were at least one item on exchange step filled in all existing dropdown attributes
	 * @return {Boolean}
	 * */
	getExchangeContinueState = (filledItems) => {
		let isSomeVariantChosen = false
		for (let i in filledItems) {
			if (filledItems.hasOwnProperty(i)) {
				if (filledItems[i]) {
					isSomeVariantChosen = true
				}
			}
		}
		return isSomeVariantChosen
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.filledItems !== this.state.filledItems) {
			if (this.getExchangeContinueState(this.state.filledItems)) {
				this.props.updateContinueState(false)
			} else {
				this.props.updateContinueState(true)
			}
		}
	}

	render() {
		let { list = [], exchangeItems = {} } = this.props
		return (
			<div>
				{list?.map((i, idx) => {
					if (i.variants) {
						return (
							<div key={idx}>
								<ExchangeItem
									item={i}
									onFilledFieldAction={
										this.onFilledFieldAction
									}
									inactive={
										exchangeItems[i.orderItemId]
											? false
											: true
									}
									isLoading={false}
								/>
								{idx < list?.length - 1 && <Separator />}
							</div>
						)
					}
				})}
			</div>
		)
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			updateContinueState,
		},
		dispatcher
	)
}

export default connect(null, matchDispatchToProps)(ExchangeItemsList)
